import { useAlertContext } from '@/contexts/alert.context.tsx';

import { Alert } from '@bancobarigui/barihaus';

export function ShowAlert() {
  const { message, type, title, dismiss } = useAlertContext();

  if (!message || !type) return <></>;

  return (
    <Alert
      type={type}
      showIcon={true}
      closable={true}
      onClose={dismiss}
      message={title || message}
      description={title ? message : undefined}
      className="fixed top-5 left-1/2 -translate-x-1/2 z-[10100] min-w-80 max-w-lg shadow-lg"
    />
  );
}
